import { Tr, Td, Text, Tooltip } from '@chakra-ui/react'
import { FC } from 'react'
import Highlighter from 'react-highlight-words'
import { MdDelete } from 'react-icons/md'

import useProfile from '@hook/shared/use-profile'

interface IProfilesModalTableTrProps {
  data: { [key: string]: any }
  onSelect: (data: any) => void
  onUpdate: () => void
}

const ParamsCenterTableTr: FC<IProfilesModalTableTrProps> = ({ data }) => {
  const { profileQuery: fastQuery } = useProfile()

  return (
    <Tr>
      <Td>
        {fastQuery.length > 0 ? (
          <Text maxW="220px" isTruncated>
            <Highlighter
              searchWords={fastQuery.split(' ')}
              textToHighlight={String(data.codigo || 'Não informado')}
            />
          </Text>
        ) : (
          <Text maxW="200px" isTruncated>
            {data.codigo || 'Não informado'}
          </Text>
        )}
      </Td>
      <Td>
        <Tooltip
          label={data.descricao || 'Não cadastrado'}
          placement="auto-start"
        >
          {fastQuery.length > 0 ? (
            <Text maxW="220px" isTruncated>
              <Highlighter
                searchWords={fastQuery.split(' ')}
                textToHighlight={String(data.descricao || 'Não informado')}
              />
            </Text>
          ) : (
            <Text maxW="220px" isTruncated>
              {data.descricao || 'Não cadastrado'}
            </Text>
          )}
        </Tooltip>
      </Td>
      <Td>
        <MdDelete width={50} />
      </Td>
    </Tr>
  )
}

export default ParamsCenterTableTr
